var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, getTestId } from '@airtel/air-design-system';
import { CarouselWidgetComponent as CarouselWidget } from '../../components/carousel-widget/CarouselWidget';
export var withCarousel = Component => {
  var Wrapper = props => {
    var _a;
    var _props$withCarousel = props.withCarousel,
      withCarousel = _props$withCarousel === void 0 ? false : _props$withCarousel,
      withCarouselProps = props.withCarouselProps,
      restProps = __rest(props, ["withCarousel", "withCarouselProps"]);
    var onUserAction = props.onUserAction;
    var carouselData = [];
    if (((_a = withCarouselProps === null || withCarouselProps === void 0 ? void 0 : withCarouselProps.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
      carouselData = withCarouselProps.data.map((_item, index) => {
        var _a;
        return (_item === null || _item === void 0 ? void 0 : _item.withCardWrapped) ? _jsx(Card, Object.assign({}, _item === null || _item === void 0 ? void 0 : _item.withCardWrappedProps, {
          style: [(_a = _item === null || _item === void 0 ? void 0 : _item.withCardWrappedProps) === null || _a === void 0 ? void 0 : _a.style]
        }, getTestId(props.testID, 'withCardWrapped'), {
          children: _jsx(Component, Object.assign({}, _item, getTestId(props.testID, "withCarousel_carouselItem_" + index), {
            onUserAction: onUserAction
          }))
        })) : _jsx(Component, Object.assign({}, _item, getTestId(props.testID, "withCarousel_carouselItem_" + index), {
          onUserAction: onUserAction
        }));
      });
    }
    return _jsx(_Fragment, {
      children: withCarousel ? _jsx(CarouselWidget, Object.assign({}, withCarouselProps, {
        data: carouselData,
        carouselType: "COMPONENT",
        onUserAction: onUserAction
      }, getTestId(props.testID, 'withCarousel'))) : _jsx(Component, Object.assign({}, restProps))
    });
  };
  return Wrapper;
};